import { Col, Row, Spinner } from "react-bootstrap"
import CardYear from "../CardYear"
import axios from "axios";
import { BASE_URL } from "../../App";
import { useEffect, useState } from "react";
import "../../styles/homepage.css";
import "../../styles/card.css";
import "../../styles/cardyears.css";
import { Link } from "react-router-dom";




function Years ({ loggedIn, auth , style  }) {

    const [levelTitle , setLevelTitle] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [level , setLevel] = useState([]);
    const [clever , setClever] = useState([]);
  
  
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      const config = {
      headers: {
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "any",
      'Authorization': `Bearer ${token}`,
      }
      };
  
      try {
      const response = await axios.get(`${BASE_URL}/api/level`, config);
      setIsLoading(false); 
      setLevel(response.data.levels);
      } catch (error) {
      setIsLoading(false); 
      console.log(error);
      }
      }
  
      useEffect(() => {
        fetchData();
      }, []);

    return (
      <>
        {!loggedIn && (
          <div
            className={`card-years  p-lg-5 pt-5    ${style ? "dark-mode" : ""}`}
          >
            <div className="title pt-5 mt-lg-5 mt-5 mb-lg-5  mb-0">
              <h1>
                المراحل <span>الدراسية</span>
              </h1>
            </div>
            {isLoading ? (
              <div className="loading-coursess   pt-5 pb-5">
                <h2 className="ms-3 mb-0 text-center">
                  {" "}
                  جاري تحميل <span>السنوات الدراسية</span>
                </h2>
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <Row className="align-items-center justify-content-center flex-row-reverse mt-3 w-100 mt-0 mb-0 ms-auto me-auto">
                {level.map((levels) => (
                  <Col lg={4} key={levels.id} className="mt-4">
                    <CardYear levels={levels} loggedIn={loggedIn} auth={auth} />
                  </Col>
                ))}
              </Row>
            )}
          </div>
        )}

        <div className={`main-about-platform ${style ? "dark-mode" : ""} `}>
          <div className={`about-platform ${style ? "dark-mode" : ""} `}>
            {/* <Container> */}

            <div className="img-main">
              <Row className="align-items-center w-100 ">
                <Col lg={6}>
              <div className={`about-all `}>
                <div className={`image `}>
                  <img className="pic-light" src="/images/dark-mode.png" alt="" loading="lazy" />
                  <img className="pic-dark" src="/images/white-1.png" alt="" loading="lazy" />
                </div>

              </div>
            </Col>
            
                <Col lg={6}>
                  <div className={`about `}>
                    <h2> 🎉! عندنا خبر جامد جدًا ليك </h2>
                    <p className="wavy-text">
                      {" "}
                      💪 دلوقتي بقى عندك سبب يخليك تذاكر بعافية وتكسر الدنيا{" "}
                      <br /> 🚀 لإننا أضفنا نظام البوينتات الجديد على منصتنا
                      الأونلاين <br /> 🔥 يعني كل خطوة إيجابية بتعملها، كل تمرين
                      بتحله، كل شطارة بتبينها... بتكسب بوينتات <br /> 🎁والبوينتات دي مش بتروح في الهوا 😏
                      تقدر تبدّلها من ستور الهدايا بتاعنا بحاجات هتعجبك جدًا 
                    </p>
                  </div>
                  <div className="pdf-content me-lg-0 mt-50">
                    <Link to="/points">
                      <span> خش يلا شوف معاك كام بوينتس </span>
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>

            {/* </Container> */}
          </div>
        </div>
      </>
    );
}

export default Years